import React from "react";
import { LOCALE_STRINGS } from "constants/locales";
import defaultImage from "assets/images/solutionFinance2.svg"; 
import { ReactComponent as CheckIcon } from "assets/icons/checkIcon.svg";

export const FeatureListSectionTwo = ({
  imageSrc = defaultImage,
  language = "EN",
}) => {
  const langKey = language?.toUpperCase?.() || "EN";
  const strings = LOCALE_STRINGS?.[langKey] || LOCALE_STRINGS?.[language] || {};

  return (
    <section className="feature-list-two-section">
      <div className="feature-list-two">
        
        <div className="feature-content-two">
          
          <div className="text-block-two">
            <h2 className="text-block-two__title">
              {strings.feature_list_two_title || "Banks don't see them. We do"}
            </h2>
            <p className="text-block-two__description">
              {strings.feature_list_two_desc ||
                "Historical financials can't capture what's happening now: suppliers paid on time, shipments clearing without incident, month after month. Ezer sees it — because we read the trade itself."}
            </p>
          </div>

          <div className="checklist-two">
            
            <div className="checklist-row-two checklist-row-two--tall">
              <div className="checklist-item-two">
                <CheckIcon />
                <span className="checklist-item-two__text">
                  {strings.feature_two_check_1 || "Payment behavior tracked across every transaction"}
                </span>
              </div>
              <div className="checklist-item-two">
                <CheckIcon />
                <span className="checklist-item-two__text">
                  {strings.feature_two_check_2 || "Shipment performance scored on delivery, not paperwork"}
                </span>
              </div>
            </div>

            <div className="checklist-row-two">
              <div className="checklist-item-two">
                <CheckIcon />
                <span className="checklist-item-two__text">
                  {strings.feature_two_check_3 || "Order history builds a live credit profile over time"}
                </span>
              </div>
              <div className="checklist-item-two">
                <CheckIcon />
                <span className="checklist-item-two__text">
                  {strings.feature_two_check_4 || "Credit lines extend as performance does"}
                </span>
              </div>
            </div>

          </div>

        </div>

        <div className="feature-image-wrapper-two">
          <img
            src={imageSrc}
            alt="Trade protection and analytics"
            className="feature-image-two"
          />
        </div>

      </div>
    </section>
  );
};